import { n as r, t as s } from "./custom-element-wb8eOGrn.js";
var a = class extends s {
  [Symbol.toStringTag] = "FlipFlop";
  constructor() {
    super();
  }
  connectedCallback() {
    this.state.add("current", 0), this.querySelector("[data-flipper]")?.addEventListener("click", () => {
      this.state.current.set(this.state.current.get() ^ 1);
    }), this.querySelectorAll("[data-item]").forEach((t, e) => {
      this.effects.push(r(() => {
        e === this.state.current.get() ? t.setAttribute("aria-current", "true") : t.removeAttribute("aria-current");
      }));
    });
  }
};
customElements.define("flip-flop", a);
